/* VIP Cart Drawer v1.1 (2026-10-12) - v1.1 adds payment logos under checkout
 * VIP Cart Drawer v1 (2026-10-12)
 * One shared slide-out cart for every add-to-cart entry point:
 *   - list / homepage cards  (onclick="addToCart('VID')")
 *   - product page           (onclick="pdpAddToCart(VID)")
 *   - search results BUY     (.vip-num-add[data-vid])
 *   - header cart icon       (header a[href="/cart"])
 * Clicks are intercepted in the capture phase, so the original handlers never
 * run and nothing is added twice. Loaded from snippets/vip-cart-drawer.liquid;
 * the guard below guarantees a single instance even if the tag appears twice.
 * The /cart page itself is untouched (cart icon navigates there as before).
 *
 * v160 (2026-11-01): immediate pending line. On tap the chosen number appears at once as a line marked
 * "Adding…" (no Remove, no price in the total). It is never shown as added until Shopify confirms; while any
 * add is pending the checkout button is unavailable. On failure the pending line is removed and the usual
 * message is shown. Cart reads are shared by assets/vip-cart-core.js (no extra requests from this file).
 *
 * v162 (draft, Nov 2026): search BUY analytics now come from assets/vip-number-search.js
 * (window.VIPSearchTrack), which sends the privacy-safe, zero-preserving search term. This file no longer
 * reads what customers type into any input. Cart behaviour is unchanged.
 */
(function () {
  'use strict';
  if (window.VIPCart) return;

  var GOLD = '#d4b85e';
  var BROWSE_URL = '/collections/available-numbers';
  var state = { cart: null, open: false, busy: false, pending: {}, pendingMeta: {}, pendingOrder: [], lastFocus: null, lastQuery: '', noticeTimer: null, highlight: null };
  var el = null;

  /* ---------- helpers ---------- */
  function noop() {}
  function money(cents, cur) {
    var v = (cents || 0) / 100;
    var whole = Math.round(v * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v);
    } catch (e) {
      return '£' + v.toLocaleString('en-GB');
    }
  }
  function mk(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = opts.headers || {};
    opts.headers['Accept'] = 'application/json';
    if (opts.body) opts.headers['Content-Type'] = 'application/json';
    opts.headers['X-Requested-With'] = 'XMLHttpRequest';
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) {
          var err = new Error((d && (d.description || d.message)) || ('HTTP ' + r.status));
          err.status = r.status;
          throw err;
        }
        return d;
      });
    });
  }
  function track(name, params) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params || {});
      }
    } catch (e) {}
  }

  /* ---------- styles ---------- */
  var CSS = [
    'html.vcd-lock,html.vcd-lock body{overflow:hidden!important}',
    '#vcdOverlay{position:fixed;inset:0;background:rgba(0,0,0,.6);opacity:0;visibility:hidden;transition:opacity .3s,visibility 0s linear .3s;z-index:2147483000}',
    '#vcdOverlay.open{opacity:1;visibility:visible;transition:opacity .3s,visibility 0s}',
    '#vcdDrawer{position:fixed;top:0;right:0;bottom:0;width:420px;max-width:100%;background:#0f0e0a;color:#f3efe4;z-index:2147483001;display:flex;flex-direction:column;transform:translateX(100%);visibility:hidden;transition:transform .32s cubic-bezier(.2,.8,.2,1),visibility 0s linear .32s;border-left:1px solid #2a2820;box-shadow:-10px 0 34px rgba(0,0,0,.5);font-family:Jost,sans-serif;-webkit-font-smoothing:antialiased}',
    '#vcdDrawer.open{transform:translateX(0);visibility:visible;transition:transform .32s cubic-bezier(.2,.8,.2,1),visibility 0s}',
    '#vcdDrawer *{box-sizing:border-box}',
    '.vcd-head{display:flex;align-items:center;justify-content:space-between;padding:22px 24px 18px;border-bottom:1px solid #2a2820}',
    '.vcd-title{margin:0;font-family:Jost,sans-serif;font-size:12px;font-weight:600;letter-spacing:3px;text-transform:uppercase;color:' + GOLD + '}',
    '.vcd-close{background:none;border:0;color:#f3efe4;font-size:26px;line-height:1;width:40px;height:40px;margin:-8px -10px -8px 0;cursor:pointer;border-radius:50%}',
    '.vcd-close:hover,.vcd-close:focus-visible{color:' + GOLD + ';outline:none;background:rgba(212,184,94,.08)}',
    '.vcd-notice{display:none;margin:14px 24px 0;padding:11px 14px;border:1px solid rgba(212,184,94,.45);background:rgba(212,184,94,.08);color:' + GOLD + ';font-size:12px;letter-spacing:.5px;line-height:1.45;border-radius:3px}',
    '.vcd-notice.show{display:block}',
    '.vcd-notice.err{border-color:rgba(224,122,106,.55);background:rgba(224,122,106,.08);color:#f0a597}',
    '.vcd-body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:6px 24px}',
    '.vcd-line{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;padding:18px 0;border-bottom:1px solid #22201a;transition:background .6s,opacity .2s}',
    '.vcd-line.hl{background:rgba(212,184,94,.07);margin:0 -24px;padding:18px 24px}',
    '.vcd-line.removing{opacity:.4;pointer-events:none}',
    '.vcd-info{min-width:0}',
    '.vcd-num{display:block;color:#f3efe4;text-decoration:none;font-size:19px;font-weight:500;letter-spacing:2px;font-variant-numeric:tabular-nums;line-height:1.3;word-break:break-word}',
    '.vcd-num:hover{color:' + GOLD + '}',
    '.vcd-sub{display:block;margin-top:4px;font-size:11px;letter-spacing:1px;color:#8f897b;text-transform:uppercase}',
    '.vcd-right{display:flex;flex-direction:column;align-items:flex-end;gap:8px;flex-shrink:0}',
    '.vcd-price{font-size:15px;font-weight:500;color:' + GOLD + ';white-space:nowrap}',
    '.vcd-remove{background:none;border:0;padding:4px 0;color:#8f897b;font-family:Jost,sans-serif;font-size:11px;letter-spacing:1px;text-transform:uppercase;cursor:pointer;text-decoration:underline;text-underline-offset:3px}',
    '.vcd-remove:hover,.vcd-remove:focus-visible{color:#f3efe4;outline:none}',
    '.vcd-foot{flex-shrink:0;padding:18px 24px calc(20px + env(safe-area-inset-bottom));border-top:1px solid #2a2820;background:#0f0e0a}',
    '.vcd-sum{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px}',
    '.vcd-sum-l{font-size:11px;letter-spacing:3px;text-transform:uppercase;color:#bdb6a6}',
    '.vcd-sum-v{font-size:22px;font-weight:600;color:#f3efe4}',
    '.vcd-note{font-size:11px;color:#8f897b;margin:0 0 16px;letter-spacing:.5px}',
    '.vcd-checkout{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;padding:17px 16px;background:' + GOLD + ';color:#0f0e0a!important;text-decoration:none;font-family:Jost,sans-serif;font-size:13px;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;border-radius:2px;transition:background .2s}',
    '.vcd-checkout:hover,.vcd-checkout:focus-visible{background:#e6cc7a;outline:none}',
    '.vcd-checkout.loading{background:#a8842f;pointer-events:none}',
    '.vcd-pay{display:flex;flex-wrap:nowrap;justify-content:center;align-items:center;gap:clamp(4px,2.4%,10px);width:100%;margin:14px 0 0;padding:0;list-style:none}',
    '.vcd-pay-i{flex:0 1 42px;min-width:0;display:flex;align-items:center}',
    '.vcd-pay-i svg{display:block;width:100%;height:auto;max-width:42px}',
    '.vcd-viewcart{display:block;text-align:center;margin-top:14px;color:#bdb6a6!important;font-size:11px;letter-spacing:2px;text-transform:uppercase;text-decoration:underline;text-underline-offset:4px}',
    '.vcd-viewcart:hover{color:' + GOLD + '!important}',
    '.vcd-empty{text-align:center;padding:56px 10px 30px}',
    '.vcd-empty p{margin:16px 0 26px;color:#bdb6a6;font-size:14px;letter-spacing:.5px}',
    '.vcd-browse{display:inline-block;padding:15px 26px;border:1.5px solid ' + GOLD + ';color:' + GOLD + '!important;background:transparent;font-family:Jost,sans-serif;font-size:12px;font-weight:600;letter-spacing:2.5px;text-transform:uppercase;text-decoration:none;cursor:pointer;border-radius:2px}',
    '.vcd-browse:hover,.vcd-browse:focus-visible{background:rgba(212,184,94,.1);outline:none}',
    '.vcd-loading{text-align:center;padding:60px 0;color:#8f897b;font-size:12px;letter-spacing:2px;text-transform:uppercase}',
    '.vcd-spin{display:inline-block;width:14px;height:14px;border:2px solid rgba(15,14,10,.35);border-top-color:#0f0e0a;border-radius:50%;animation:vcdspin .7s linear infinite}',
    '@keyframes vcdspin{to{transform:rotate(360deg)}}',
    '@media (max-width:480px){#vcdDrawer{width:100%;border-left:0}.vcd-head{padding:18px 18px 14px}.vcd-body{padding:4px 18px}.vcd-line.hl{margin:0 -18px;padding:18px}.vcd-notice{margin:12px 18px 0}.vcd-foot{padding:16px 18px calc(18px + env(safe-area-inset-bottom))}.vcd-num{font-size:18px}}',
    '.vcd-line.vcd-pending{opacity:.78}',
    '.vcd-pending .vcd-num{cursor:default}',
    '.vcd-pending .vcd-sub{color:' + GOLD + '}',
    '.vcd-spin-g{display:inline-block;width:9px;height:9px;margin-right:7px;border:1.5px solid rgba(212,184,94,.3);border-top-color:' + GOLD + ';border-radius:50%;animation:vcdspin .7s linear infinite;vertical-align:0}',
    '.vcd-checkout.vcd-wait{opacity:.45;pointer-events:none;cursor:default}',
    '@media (prefers-reduced-motion:reduce){#vcdDrawer,#vcdOverlay{transition:none!important}.vcd-spin-g{animation:none}}'
  ].join('\n');

  /* ---------- DOM (built lazily on first use) ---------- */
  function build() {
    if (el) return;
    var style = mk('style');
    style.id = 'vcdStyles';
    style.textContent = CSS;
    document.head.appendChild(style);

    var overlay = mk('div');
    overlay.id = 'vcdOverlay';
    overlay.addEventListener('click', close);

    var drawer = mk('aside');
    drawer.id = 'vcdDrawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Your cart');
    drawer.setAttribute('aria-hidden', 'true');

    var head = mk('div', 'vcd-head');
    var title = mk('h2', 'vcd-title', 'Your Cart');
    var closeBtn = mk('button', 'vcd-close', '×');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close cart');
    closeBtn.addEventListener('click', close);
    head.appendChild(title);
    head.appendChild(closeBtn);

    var notice = mk('div', 'vcd-notice');
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');

    var body = mk('div', 'vcd-body');
    var foot = mk('div', 'vcd-foot');

    drawer.appendChild(head);
    drawer.appendChild(notice);
    drawer.appendChild(body);
    drawer.appendChild(foot);
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href],button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    el = { overlay: overlay, drawer: drawer, title: title, close: closeBtn, notice: notice, body: body, foot: foot };
  }

  /* ---------- render ---------- */
  function onBrowsePage() { return location.pathname.indexOf(BROWSE_URL) === 0; }

  function pendingList() {
    var out = [];
    for (var i = 0; i < state.pendingOrder.length; i++) {
      var v = state.pendingOrder[i], m = state.pendingMeta[v];
      if (m && !findLine(+v)) out.push(m);
    }
    return out;
  }
  function pendingLine(m) {
    var line = mk('div', 'vcd-line vcd-pending');
    line.setAttribute('aria-busy', 'true');
    var info = mk('div', 'vcd-info');
    info.appendChild(mk('span', 'vcd-num', m.title));
    var sub = mk('span', 'vcd-sub');
    sub.appendChild(mk('span', 'vcd-spin-g'));
    sub.appendChild(document.createTextNode('Adding…'));
    info.appendChild(sub);
    var right = mk('div', 'vcd-right');
    if (m.price) right.appendChild(mk('span', 'vcd-price', m.price));
    line.appendChild(info);
    line.appendChild(right);
    return line;
  }

  function render() {
    if (!el) return;
    var c = state.cart;
    var pend = pendingList();
    el.body.innerHTML = '';
    el.foot.innerHTML = '';
    if (pend.length && (!c || !c.items || !c.items.length)) {
      /* v160: nothing confirmed yet - show only the pending line(s); no total, no checkout */
      el.title.textContent = 'Your Cart';
      pend.forEach(function (m) { el.body.appendChild(pendingLine(m)); });
      el.foot.style.display = 'none';
      return;
    }
    if (!c) {
      el.body.appendChild(mk('div', 'vcd-loading', 'Loading…'));
      el.foot.style.display = 'none';
      el.title.textContent = 'Your Cart';
      return;
    }
    el.title.textContent = c.item_count > 0 ? 'Your Cart (' + c.item_count + ')' : 'Your Cart';

    if (!c.items || !c.items.length) {
      el.foot.style.display = 'none';
      var empty = mk('div', 'vcd-empty');
      empty.appendChild(mk('div', null, '')).innerHTML = '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="' + GOLD + '" stroke-width="1.5" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
      empty.appendChild(mk('p', null, 'Your cart is empty.'));
      var browse = mk('a', 'vcd-browse', 'Browse Available Numbers');
      browse.href = BROWSE_URL;
      browse.addEventListener('click', function (e) {
        if (onBrowsePage()) { e.preventDefault(); close(); }
      });
      empty.appendChild(browse);
      el.body.appendChild(empty);
      return;
    }

    c.items.forEach(function (it) {
      var line = mk('div', 'vcd-line');
      line.setAttribute('data-vid', it.variant_id);
      var info = mk('div', 'vcd-info');
      var num = mk('a', 'vcd-num', it.product_title || it.title);
      num.href = it.url || '#';
      info.appendChild(num);
      var sub = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : (it.quantity > 1 ? 'Qty ' + it.quantity : '');
      if (sub) info.appendChild(mk('span', 'vcd-sub', sub));
      var right = mk('div', 'vcd-right');
      right.appendChild(mk('span', 'vcd-price', money(it.final_line_price, c.currency)));
      var rm = mk('button', 'vcd-remove', 'Remove');
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Remove ' + (it.product_title || it.title) + ' from cart');
      rm.addEventListener('click', function () { removeLine(it.key, line, rm); });
      right.appendChild(rm);
      line.appendChild(info);
      line.appendChild(right);
      if (state.highlight && state.highlight === it.variant_id) line.classList.add('hl');
      el.body.appendChild(line);
    });
    pend.forEach(function (m) { el.body.appendChild(pendingLine(m)); });

    el.foot.style.display = '';
    var sum = mk('div', 'vcd-sum');
    sum.appendChild(mk('span', 'vcd-sum-l', 'Total'));
    sum.appendChild(mk('span', 'vcd-sum-v', money(c.total_price, c.currency)));
    el.foot.appendChild(sum);
    el.foot.appendChild(mk('p', 'vcd-note', 'Same-day PAC code'));
    var co = mk('a', 'vcd-checkout');
    co.href = '/checkout';
    co.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg><span>Continue to checkout</span>';
    if (pend.length) {
      /* v160: checkout stays unavailable until every pending add is confirmed by Shopify */
      co.classList.add('vcd-wait');
      co.setAttribute('aria-disabled', 'true');
      co.setAttribute('tabindex', '-1');
    }
    co.addEventListener('click', function (e) {
      if (co.classList.contains('vcd-wait')) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      co.classList.add('loading');
      co.innerHTML = '<span class="vcd-spin"></span><span>Taking you to secure checkout…</span>';
    });
    el.foot.appendChild(co);
    /* Payment logos: official Shopify payment_type_svg_tag icons, rendered by
       snippets/vip-cart-drawer.liquid into <template id="vcdPayIcons">, only for
       types the shop currently has enabled. */
    var payTpl = document.getElementById('vcdPayIcons');
    if (payTpl && payTpl.content) el.foot.appendChild(payTpl.content.cloneNode(true));
    var vc = mk('a', 'vcd-viewcart', 'View cart');
    vc.href = '/cart';
    el.foot.appendChild(vc);

    if (state.highlight) {
      var hl = el.body.querySelector('.vcd-line.hl');
      if (hl && hl.scrollIntoView) { try { hl.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
      var h = state.highlight;
      setTimeout(function () {
        if (state.highlight === h) state.highlight = null;
        var x = el && el.body.querySelector('.vcd-line.hl');
        if (x) x.classList.remove('hl');
      }, 2500);
    }
  }

  function notice(msg, type) {
    build();
    clearTimeout(state.noticeTimer);
    el.notice.textContent = msg;
    el.notice.className = 'vcd-notice show' + (type === 'error' ? ' err' : '');
    if (type === 'ok') state.noticeTimer = setTimeout(clearNotice, 3500);
  }
  function clearNotice() {
    if (!el) return;
    clearTimeout(state.noticeTimer);
    el.notice.className = 'vcd-notice';
    el.notice.textContent = '';
  }

  function syncBadge(c) {
    var b = document.querySelectorAll('#cartBadge');
    for (var i = 0; i < b.length; i++) {
      b[i].textContent = c.item_count;
      b[i].style.display = c.item_count > 0 ? 'flex' : 'none';
    }
  }

  function setCart(c) {
    state.cart = c;
    syncBadge(c);
    render();
    return c;
  }
  function refresh() { return jsonFetch('/cart.js').then(setCart); }

  /* ---------- open / close ---------- */
  function open() {
    build();
    if (!state.cart) render();
    if (state.open) return;
    state.open = true;
    state.lastFocus = document.activeElement;
    el.overlay.classList.add('open');
    el.drawer.classList.add('open');
    el.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vcd-lock');
    setTimeout(function () { try { el.close.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close() {
    if (!el || !state.open) return;
    state.open = false;
    el.overlay.classList.remove('open');
    el.drawer.classList.remove('open');
    el.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vcd-lock');
    clearNotice();
    var f = state.lastFocus;
    if (f && f.focus && document.contains(f)) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- add / remove ---------- */
  function findLine(vid) {
    var items = (state.cart && state.cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].variant_id === vid) return items[i];
    return null;
  }
  function friendly(msg) {
    if (/sold out|not available|unavailable/i.test(msg)) return 'Sorry — this number has just been sold.';
    if (/already|only add|maximum|can.t add more/i.test(msg)) return 'This number is already in your cart';
    return 'Sorry, this number could not be added. Please try again.';
  }

  /* Returns 'added' | 'duplicate' | 'pending' | 'error' */
  function clearPending(vid) {
    delete state.pendingMeta[vid];
    var i = state.pendingOrder.indexOf(vid);
    if (i > -1) state.pendingOrder.splice(i, 1);
  }
  function add(vid, meta) {
    vid = parseInt(vid, 10);
    if (!vid) return Promise.resolve('error');
    build();
    if (state.pending[vid]) { open(); return Promise.resolve('pending'); }
    state.pending[vid] = true;
    /* v160: show the number at once as "Adding…" (not as added) unless we already know it is in the cart */
    if (meta && meta.title && !(state.cart && findLine(vid))) {
      state.pendingMeta[vid] = meta;
      if (state.pendingOrder.indexOf(vid) === -1) state.pendingOrder.push(vid);
      render();
    } else if (!state.cart) { render(); }
    open();
    return refresh().catch(noop).then(function () {
      if (findLine(vid)) {
        clearPending(vid);
        state.highlight = vid;
        render();
        notice('This number is already in your cart', 'info');
        return 'duplicate';
      }
      return jsonFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function () {
          state.highlight = vid;
          return refresh();
        })
        .then(function () {
          notice('Added to your cart ✓', 'ok');
          return 'added';
        });
    }).catch(function (err) {
      var m = friendly((err && err.message) || '');
      notice(m, /already/.test(m) ? 'info' : 'error');
      clearPending(vid);
      render();
      refresh().catch(noop);
      return /already/.test(m) ? 'duplicate' : 'error';
    }).then(function (res) {
      delete state.pending[vid];
      if (state.pendingMeta[vid]) { clearPending(vid); render(); }
      return res;
    });
  }

  function removeLine(key, line, btn) {
    if (state.busy) return;
    state.busy = true;
    btn.disabled = true;
    line.classList.add('removing');
    clearNotice();
    jsonFetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(setCart)
      .catch(function () {
        notice('Could not remove this number. Please try again.', 'error');
        return refresh().catch(function () { line.classList.remove('removing'); btn.disabled = false; });
      })
      .then(function () { state.busy = false; });
  }

  /* ---------- entry-point adapters ---------- */
  function txt(n) { return n ? (n.innerText || n.textContent || '').replace(/\s*\n\s*/g, ' & ').replace(/\s+/g, ' ').trim() : ''; }
  function metaFor(btn) {
    try {
      if (btn.id === 'pdpAddToCart') return { title: txt(document.querySelector('.vip-pdp-title')), price: txt(document.querySelector('.vip-pdp-price')) };
      var card = btn.closest('.num-card, .vip-card, [data-num]');
      if (card) {
        var t = txt(card.querySelector('.card-num, .num, .vip-card-num')) || card.getAttribute('data-num') || '';
        var pz = txt(card.querySelector('.price, .card-price, .vip-card-price'));
        if (t) return { title: t, price: pz };
      }
    } catch (e) {}
    return null;
  }
  function handleCardButton(btn, vid) {
    var isPdp = btn.id === 'pdpAddToCart';
    if (btn.getAttribute('aria-busy') === 'true') { open(); return; }
    btn.setAttribute('aria-busy', 'true');
    var orig = btn.textContent;
    if (isPdp) btn.textContent = 'Adding…';
    else btn.style.opacity = '.6';
    add(vid, metaFor(btn)).then(function (res) {
      if (isPdp) {
        btn.textContent = res === 'added' ? 'Added ✓' : (res === 'duplicate' ? 'In your cart' : orig);
        setTimeout(function () { btn.textContent = orig; }, 2000);
      } else {
        btn.style.opacity = '';
      }
      btn.removeAttribute('aria-busy');
    });
  }

  function handleSearchBuy(btn) {
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-vid');
    btn.disabled = true;
    btn.textContent = '…';
    var sNum = btn.getAttribute('data-num') || '', sPrice = Number(btn.getAttribute('data-price')) || 0;
    var ST = window.VIPSearchTrack;
    try { if (ST) ST.commit('buy'); } catch (e) {}   /* v162 analytics: BUY completes the search intention */
    add(vid, sNum ? { title: sNum, price: sPrice ? money(sPrice * 100) : '' } : null).then(function (res) {
      if (res === 'added' || res === 'duplicate' || res === 'pending') {
        btn.textContent = '✓';
        btn.style.background = GOLD;
        btn.style.color = '#0f0e0a';
        if (res === 'added') {
          try { if (ST) ST.addToCart(btn); } catch (e) {}   /* v162: safe term, leading zeros kept */
        }
      } else {
        btn.disabled = false;
        btn.textContent = 'BUY';
        btn.style.background = 'transparent';
        btn.style.color = GOLD;
      }
    });
  }

  var ADD_SEL = '[onclick*="addToCart("],[onclick*="AddToCart("]';
  var ICON_SEL = 'header a[href="/cart"], a[aria-label="Cart"][href="/cart"]';

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (el && el.drawer.contains(t)) return;

    var s = t.closest('.vip-num-add');
    if (s && s.hasAttribute('data-vid')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleSearchBuy(s);
      return;
    }

    var b = t.closest(ADD_SEL);
    if (b) {
      var m = (b.getAttribute('onclick') || '').match(/addToCart\(\s*['"]?(\d+)/i);
      if (m) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCardButton(b, m[1]);
      }
      return;
    }

    var a = t.closest(ICON_SEL);
    if (a && !/^\/cart\/?$/.test(location.pathname) && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && e.button === 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      refresh().catch(function () { location.href = '/cart'; });
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });

  /* Back from checkout (bfcache): resync badge and drawer */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      if (el) { var co = el.foot.querySelector('.vcd-checkout.loading'); if (co) render(); }
      refresh().catch(noop);
    }
  });

  window.VIPCart = { open: open, close: close, add: add, refresh: refresh };
})();
